import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { InputTrimModule } from 'ng2-trim-directive';
import { TooltipModule } from 'ng2-tooltip-directive';
import { HttpClientModule } from '@angular/common/http';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './loader/loader.service';
import { ManageTeamComponent } from './manage-team/manage-team.component';
import { HideIfUnauthorized } from './directives/hide-if-unathorized.directive';
import { DisableIfUnauthorizedDirective } from './directives/disable-if-unathorized.directive';
import { HideIfUnauthorizedTenant } from './directives/hideTenantIfUnauthorized.directive';
import { HideIfUnauthorizedApp } from './directives/hideApp-if-unauthorized.directive';
import { DisplayImage } from './directives/blobToImage';
import { ApplicationDisplayImage } from './directives/blobToApplicationImage';
import { ClickElsewhereDirective } from './directives/click-outside.directive';
import { UserAvatar } from './directives/buildAvatarBasedOnUserName';
import { NgSelectModule } from '@ng-select/ng-select';
import { TrimGuidFromFileName } from './directives/trim-guid';
import { ApplicationFilterComponent } from './application-filter/application-filter.component';

@NgModule({
  declarations: [
    ManageTeamComponent,
    HideIfUnauthorized,
    DisableIfUnauthorizedDirective,
    HideIfUnauthorizedTenant,
    HideIfUnauthorizedApp,
    DisplayImage,
    ApplicationDisplayImage,
    ClickElsewhereDirective,
    UserAvatar,
    TrimGuidFromFileName,
    ApplicationFilterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTrimModule, 
    TooltipModule,
    NgSelectModule,   
    ToastrModule.forRoot({     
      timeOut: 2000,
      positionClass: 'toast-bottom-center',
      preventDuplicates:true
    })
  ],
  exports:[
    ManageTeamComponent,
    HideIfUnauthorized,
    DisableIfUnauthorizedDirective,
    HideIfUnauthorizedTenant,
    HideIfUnauthorizedApp,
    DisplayImage,
    ApplicationDisplayImage,
    ClickElsewhereDirective,
    UserAvatar,
    TrimGuidFromFileName,
    ApplicationFilterComponent
  ]
})
export class SharedModule { }
